export const getOriginalVimeoThumbnail = (
	url: string | undefined | null,
): string | undefined => {
	return url ? url.split("_")[0] : undefined;
};
